/*
 * In this file, all kinds of initializations that vary from project to project are performed.
 */
/**
 * Constants
 */
import { DOCUMENT_ELEMENT } from '@/scripts/constants';

/**
 * Polyfills
 */
import '@/scripts/utils/IIFE/polyfil';
import '@/scripts/utils/IIFE/table-responsive';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';

/**
 * Utils
 */
import { TweenLite, Power1 } from 'gsap/TweenMax';
import 'EasePack';
import 'ScrollToPlugin';
import 'letteringjs';
import LazyLoad from 'vanilla-lazyload';
import NProgress from 'nprogress';
import { loadFonts } from '@/scripts/utils';

/**
 * Basic Components
 */
import {
  Preloader,
  VideoModal,
  GalleryModal,
  initCookies,
  // Page navigation + PJAX (BarbaJS)
  PageNavigation,
  BookNowDropdown
} from '@/components';

/**
 * Assets
 */
import '@/fonts';
import 'nprogress/nprogress.css';
import '@/styles/main.scss';

loadFonts(['Muli:300,400,600,700:latin']);
TweenLite.defaultEase = Power1.easeOut;

// configure progress bar

NProgress.configure({
  minimum: 0.1,
  trickleSpeed: 200,
  showSpinner: false,
});

const initBasics = () => new Promise((resolve) => {
  // set css transition-duration to get it in JS
  const duration = getComputedStyle(document.documentElement)['transition-duration'];
  document.documentElement.dataset.duration = parseFloat(duration);

  // Object fit polyfill
  objectFitImages(); // https://www.npmjs.com/package/object-fit-images
  objectFitVideos(); // https://www.npmjs.com/package/object-fit-videos

  // init cookies bar
  initCookies();

  // Lazy load images
  // https://github.com/verlok/lazyload
  const lazy = new LazyLoad({
    elements_selector: '[data-lazy-loading="true"]',
    threshold: 1000,
  });
  DOCUMENT_ELEMENT.addEventListener('lazy:update', () => {
    lazy.update();
  });

  resolve(true);
});

const initModals = () => new Promise((resolve) => {
  // init video modal element
  const videoModal = new VideoModal(); // eslint-disable-line no-unused-vars

  const galleryModal = new GalleryModal(); // eslint-disable-line no-unused-vars

  resolve([videoModal, galleryModal]);
});

document.addEventListener('DOMContentLoaded', async () => {
  const preloader = new Preloader({
    element: document.querySelector('[data-role="preloader"]'),
  });
  const pageNavigation = new PageNavigation({
    usePJAX: false,
  });
  preloader.startLoading();
  const loaded = [
    await initBasics(),
    await initModals(),
    await pageNavigation.init(),
  ];
  BookNowDropdown();
  if (loaded) {
    preloader.play();
  }
});



// WEBPACK FOOTER //
// ./scripts/common.js